import { render, staticRenderFns } from "./local_goodsList.vue?vue&type=template&id=0428b8b2&scoped=true"
import script from "./local_goodsList.vue?vue&type=script&lang=js"
export * from "./local_goodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428b8b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0428b8b2')) {
      api.createRecord('0428b8b2', component.options)
    } else {
      api.reload('0428b8b2', component.options)
    }
    module.hot.accept("./local_goodsList.vue?vue&type=template&id=0428b8b2&scoped=true", function () {
      api.rerender('0428b8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/local_goodsList.vue"
export default component.exports